var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    fill: "#1F72CD",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73617 9L2.74219 15.8205H6.32641L6.77075 14.733H7.78641L8.23075 15.8205H12.176V14.9905L12.5275 15.8205H14.5683L14.9198 14.9729V15.8205H23.1248L24.1225 14.7612L25.0567 15.8205L29.271 15.8292L26.2675 12.4293L29.271 9H25.1221L24.1509 10.0397L23.2461 9H14.3201L13.5537 10.7604L12.7692 9H9.19248V9.80175L8.79459 9H5.73617ZM6.42967 9.96826H8.17679L10.1627 14.5933V9.96826H12.0766L13.6105 13.2844L15.0241 9.96826H16.9285V14.8624H15.7697L15.7603 11.0274L14.0709 14.8624H13.0344L11.3356 11.0274V14.8624H8.95178L8.49986 13.7652H6.05828L5.60729 14.8614H4.33008L6.42967 9.96826ZM22.701 9.96826H17.9893V14.8595H22.628L24.1231 13.2385L25.5642 14.8595H27.0707L24.8811 12.4281L27.0707 9.96826H25.6296L24.142 11.5707L22.701 9.96826ZM7.2801 10.7965L6.47569 12.7511H8.08357L7.2801 10.7965ZM19.1523 11.8752V10.9818V10.981H22.0923L23.3751 12.4098L22.0355 13.8464H19.1523V12.871H21.7228V11.8752H19.1523Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAmex);
export default __webpack_public_path__ + "static/media/IconAmex.df2417db.svg";
export { ForwardRef as ReactComponent };